module.exports = "<div class=\"usc-store\">\r\n  <div class=\"row no-gutters usc_table_bar\">&nbsp;</div>\r\n  <br/>\r\n  <div [class]=\"loading_class\">Loading Reports...</div>\r\n  <iframe id=\"ifHome\" [src]=\"url\" width=\"100%\" style=\"border: 0px;\" (load)=\"onload($event)\" [class]=\"display_class\" scrolling=\"no\"></iframe>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-reports/usc-reports.component.html
// module id = ../../../../../src/app/components/usc-store/usc-reports/usc-reports.component.html
// module chunks = main